<div askModalHeader class="modal-header">
  <h2 class="title">
    {{ modalTitle | translate }}
  </h2>
</div>

<div askModalBody class="modal-body" *ngIf="formGroup">
  <form class="templates-form" [formGroup]="formGroup">
    <div class="form-field">
      <label for="shortcutCommand">{{ "SHORTCUT_COMMAND" | translate }}:</label>

      <div class="input-group">
        <input
          type="text"
          id="shortcutCommand"
          class="field"
          formControlName="title"
          [placeholder]="'TYPE_COMMAND_HERE' | translate"
          askAutofocus
        />
        <div class="box">/</div>
      </div>
    </div>

    <div class="form-field" *ngIf="companies.length > 1">
      <label for="companies">{{ "COMPANIES" | translate }}:</label>

      <ask-autocomplete
        id="companies"
        *ngIf="companies"
        [allOptionsSelectedText]="'ALL_COMPANIES_SELECTED' | translate"
        [displayFn]="displayFn"
        [filterFn]="filterFn"
        [multiple]="true"
        [options]="companies"
        formControlName="companiesIds"
        [placeholder]="'SELECT_COMPANIES' | translate"
        [selectAll]="true"
        data-testid="company-select"
        valueProp="companyId"
      ></ask-autocomplete>
    </div>

    <div class="form-field">
      <label for="answer">{{ "ANSWER" | translate }}:</label>
      <div class="counter-container">
        <div style="position: relative" *ngIf="isEmojiSuggestionsVisible()">
          <app-emoji-suggestion
            [suggestions]="emojisSuggestionItem()"
            [selectedIndex]="selectedEmojiIndex"
            [isVisible]="isEmojiSuggestionsVisible()"
            (suggestionSelected)="selectEmojiSuggestion($event)"
            (suggestionHighlighted)="onFocusSuggestion($event)"
            (closed)="closeEmojiSuggestion()"
          ></app-emoji-suggestion>
        </div>
        <div class="field -editor">
          <div class="emoji-button-container">
            <ask-button-v2
              appearance="transparent"
              data-testid="emoji-picker-button"
              class="emoji-picker"
              (onClick)="onEmojiPickerOpen($event)"
              [selected]="isEmojiPickerVisible()"
              askTooltip
              [disabled]="!isFocused"
              askTooltipPosition="above"
              [askTooltipMessage]="'EMOJI.EMOJILIST' | translate"
            >
              <app-icon name="mood" />
            </ask-button-v2>
          </div>
          <div
            class="editor-container"
            askRichtextToolbox
            formControlName="content"
            (inputFocus)="onFocus()"
            (inputChange)="onInputChange()"
            [rtTools]="richtext.tools"
            [rtPlaceholder]="'TYPE_ANSWER_HERE' | translate"
            [rtBreakOnEnter]="true"
            rtType="topbar"
          ></div>
        </div>
        <div class="count-info">
          <ask-character-counter
            *ngIf="exceededLimit"
            class="counter"
            [count]="remainingAnswerCharacters"
            askTooltip
            [askTooltipMessage]="
              characterCounterTooltip
                | translate : { num: remainingAnswerCharacters }
            "
          />
          <span class="character"
            >{{ "ALERT_LIMIT_CHARACTERS.COUNT_CHARACTERS" | translate }}
            {{ countCharacters }}
          </span>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="alert_limit" *ngIf="showAlert">
  <div class="title-alert">
    <img
      [src]="'assets/icons/alert_icon_ask_6733.svg'"
      [ngClass]="{ 'img-dark': getClassDarkLight() }"
      alt="icon"
    />
    <span class="message-title">
      {{ "ALERT_LIMIT_CHARACTERS.CHARACTER_LIMIT_TITLE" | translate }}
    </span>
  </div>
  <span *ngIf="exceededLimit" class="message-alert">
    {{ "ALERT_LIMIT_CHARACTERS.ALERT_LIMIT_MAX" | translate }}
  </span>
  <span *ngIf="!exceededLimit" class="message-alert">
    {{ "ALERT_LIMIT_CHARACTERS.DESCRIPTION_ALERT" | translate }}
  </span>
  <div
    *ngIf="!exceededLimit"
    data-testid="limits-channel"
    class="limits-channel"
  >
    <span class="message-alert">
      {{ "ALERT_LIMIT_CHARACTERS.INSTAGRAM_LIMIT" | translate }}
    </span>
    <span class="message-alert">
      {{ "ALERT_LIMIT_CHARACTERS.FACEBOOK_LIMIT" | translate }}
    </span>
    <span class="message-alert">
      {{ "ALERT_LIMIT_CHARACTERS.WHATSAPP_LIMIT" | translate }}
    </span>
  </div>
  <span *ngIf="!exceededLimit" class="message-alert">
    {{ "ALERT_LIMIT_CHARACTERS.ALERT_GUIDANCE" | translate }}
  </span>
</div>
<div askModalFooter class="modal-footer">
  <ask-button
    type="secondary"
    id="cancel"
    (onClick)="close(); logCancelClick()"
    >{{ "ACTIONS.CANCEL" | translate }}</ask-button
  >

  <ask-button
    type="primary"
    (onClick)="save(); logSaveClick()"
    [loading]="loading"
    [disabled]="loading || exceededLimit"
  >
    {{ "ACTIONS.SAVE" | translate }}
  </ask-button>
</div>
